/**
 * Format an ISO date string for an application deadline chip.
 *
 *  • Returns null for missing or unparseable dates (caller should hide
 *    the badge entirely rather than showing "Deadline: —").
 *  • `urgent = true` when the deadline is within the next 30 days —
 *    UI code flips the chip into rose to draw the eye.
 *  • Relative label only kicks in inside a ~60-day window to avoid
 *    "in 342 days" noise.
 */
export function formatDeadline(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  const diffMs = d.getTime() - now.getTime();
  const days = Math.round(diffMs / (24 * 3600 * 1000));
  const pretty = d.toLocaleDateString(undefined, {
    day: "numeric", month: "short", year: "numeric",
  });
  let relative = "";
  if (days < 0)         relative = `${-days} days ago`;
  else if (days === 0)  relative = "today";
  else if (days === 1)  relative = "tomorrow";
  else if (days < 60)   relative = `in ${days} days`;
  return { pretty, relative, urgent: days >= 0 && days <= 30, past: days < 0 };
}
